import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Button } from 'primeng/button';
import { AuthService } from '#services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [TranslatePipe, Button],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  private authService: AuthService = inject(AuthService);

  protected fullName = '';
  protected hasAccess = false;

  constructor() {
    this.authService.userDetails$
      .pipe(
        filter(userDetails => userDetails !== null),
        takeUntilDestroyed()
      )
      .subscribe(({ username: fullName = 'Unknown', hasAccess = false }) => {
        this.hasAccess = hasAccess;
        this.fullName = fullName;
      });
  }

  onSupportClick() {
    window.location.href = '/support';
  }

  onUserGuideClick() {
    window.open(
      'https://chevron.sharepoint.com/:f:/r/sites/Surface-FacilityandEquipmentOperationsProductLine/Shared%20Documents/OE-Process%20Safety/Mobile%20PSSR/PSSR%20Tutorial%20and%20Guide?csf=1&web=1&e=bkWZed',
      '_blank'
    );
  }
}
